<template>
  <div v-if="appointment">
    <tab-title
      :car-id="appointment.car.id"
      text="修復歴" />
    <v-layout
      v-if="dataLoaded"
      class="mb-3"
    >
      <v-flex md12>
        <v-form ref="form">
          <cp-radio
            v-model="appointment.car.hasRepairHistory"
            :items="options"
            :rules="[$rules.isRequired]"
            label="骨格部位に異常(修正・交換・歪み) *"
            data-label-scroll="hasRepairHistory"
            @change="(value) => updateCar({ field: 'hasRepairHistory', value })"
          />
        </v-form>
      </v-flex>
    </v-layout>
    <cp-repairs
      v-if="carId"
      v-show="appointment.car.hasRepairHistory === '1'"
      :key="appointment.car.hasRepairHistory === '1'"
      :car-id="carId"
      client-arrived
      @ready="onSchemeReady"
    />
    <v-divider class="my-5" />
    <v-btn
      outline
      color="info"
      block
      large
      @click="goToNext">次へ</v-btn>
  </div>
</template>

<script>
import { getCarWith } from '../../queries';

export default {
  props: {
    appointmentId: {
      type: [String, Number],
      default: '',
    },
  },
  apollo: {
    appointment: {
      query: getCarWith(['hasRepairHistory']),
      fetchPolicy: 'network-only',
      variables() {
        return { id: parseInt(this.$route.params.id, 10) };
      },
      result({ data }) {
        this.carId = data.appointment.car.id;
        this.selfInspectionFlag = data.appointment.selfInspectionFlag;
      },
    },
  },
  data() {
    return {
      dataLoaded: false,
      carId: null,
      options: [
          { value: '1', text: 'あり' },
          { value: '0', text: 'なし' },
      ],
      selfInspectionFlag: null,
    };
  },
  methods: {
    onSchemeReady(params) {
      this.dataLoaded = true;
      this.showScheme = params.filled ? 1 : null;
    },
    goToNext() {
      const nextTab = (this.selfInspectionFlag === '1') ? 'confirm-for-self-ins' : 'evaluation';
      this.$router.push(`/inspection/${this.appointmentId}/${nextTab}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tabs/RepairsSchemeTab.vue